module.exports = __webpack_public_path__ + "img/card-occupation-default.a9af61e.png";